import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { Alert, Button } from 'antd';
import Translate from 'react-translate-component';
import { parseString } from 'xml2js';
import { contains, compose, head, map, mapObjIndexed } from 'ramda';

import {
    CONTACT,
    INTERVIEW_RECRUTER,
    INTERVIEW_CONTACT,
    VERIFICATE_RECOMENDATION,
    PROJECT_SOME_FORM,
    ORG_SOME_FORM,
    MARKETING,
} from 'constants/xmlDocumentTypes';
import { putDocumentXML } from 'actions/asyncActions';
import { filterObjectKeys } from 'utils/ramdaAdditions';
import { strToDate } from 'mappers/commonMapper';
import Client from 'components/modals/events/result/forms/xml/Client';
import EmplInterview from 'components/modals/events/result/forms/xml/EmplInterview';
import VerificateRecomendation from 'components/modals/events/result/forms/xml/VerificateRecomendation';
import PhoneContact from 'components/modals/events/result/forms/xml/PhoneContact';
import SomeFormMain from 'components/modals/events/result/forms/xml/SomeFormMain';
import Marketing from 'components/modals/events/result/forms/xml/Marketing';
import ErrorHTML from 'components/common/form/ErrorHTML';
import withFormWrapper from 'components/hocs/withFormWrapper';

const systemXMLBlocks = [
    'docinfo',
    'docmonitor',
];

const xmlDateFields = [
    'INTDATE',
    'VERREKDATE',
    'DATE',
    'NEXTDATE',
];

const xmlForms = {
    [CONTACT]: PhoneContact,
    [INTERVIEW_CONTACT]: Client,
    [INTERVIEW_RECRUTER]: EmplInterview,
    [VERIFICATE_RECOMENDATION]: VerificateRecomendation,
    [PROJECT_SOME_FORM]: SomeFormMain('project'),
    [ORG_SOME_FORM]: SomeFormMain('company'),
    [MARKETING]: Marketing,
};

const mapDateFields = mapObjIndexed(
    (value, name) => contains(name, xmlDateFields) ? strToDate(value) : value
);
const parseXML = compose(
    map(compose(mapDateFields, mapObjIndexed(head), head)),
    filterObjectKeys(name => !contains(name, systemXMLBlocks)),
);

@asyncConnect({
    formAction: putDocumentXML
        .withSuccessHandler(({ close }) => close())
        .withOptions({ resetOnUnmount: true })
})
@withFormWrapper({
    scrollToInvalid: '.ant-modal-body',
    mapPropsToValues: ({ document, initialValues }) => ({
        ...initialValues,
        id: document.id,
        type: document.xmlType
    })
})
class DocumentEditXMLForm extends Component {
    static propTypes = {
        footer: PropTypes.func.isRequired,
        document: PropTypes.object.isRequired,
        className: PropTypes.string,
        formAction: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func,
        close: PropTypes.func,
        form: PropTypes.object
    };

    render() {
        const { document, footer, handleSubmit, className, close, form } = this.props;
        const { meta } = this.props.formAction;

        const FormComponent = xmlForms[document.xmlType];

        return (
            <div className={className}>
                { FormComponent ? (
                    <Fragment>
                        <FormComponent change={form.change} />
                        {meta.error && <ErrorHTML meta={meta} />}
                        {footer(handleSubmit)}
                    </Fragment>
                ) : (
                    <Fragment>
                        <Alert
                            message={<Translate content='events.formNotSet' />}
                            type='info'
                        />
                        <Button className="card-button close-button" onClick={close}>
                            <Translate content="events.cancel" />
                        </Button>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default class DocumentEditXML extends Component {
    state = {
        xml: null
    }

    componentDidMount() {
        const { body } = this.props.body;

        parseString(body, (error, result) => {
            if (result) {
                result = {
                    xmlbody: parseXML(result.xmlbody)
                };
            }

            this.setState({
                xml: {
                    result: result || {}
                }
            });
        });
    }

    render() {
        const { xml } = this.state;

        return xml && (
            <DocumentEditXMLForm
                initialValues={xml}
                {...this.props}
            />
        );
    }
}
